import React, { useContext } from "react";
import { AppContext } from "../States/AppContext";

// styles
import { PopUpBodyText } from "./PopUpBody.elements";

const PopUpBody = ({ popuppage }) => {
  const { state, setState } = useContext(AppContext);

  const body = popuppage.body.map((paragraph, index) => {
    return <PopUpBodyText key={index}>{paragraph}</PopUpBodyText>;
  });

  const bodyOnText = popuppage.bodyOn.map((paragraph, index) => {
    return <PopUpBodyText key={index}>{paragraph}</PopUpBodyText>;
  });

  const bodyOffText = popuppage.bodyOff.map((paragraph, index) => {
    return <PopUpBodyText key={index}>{paragraph}</PopUpBodyText>;
  });

  const bodyPicOffText = popuppage.bodyPicOff.map((paragraph, index) => {
    return <PopUpBodyText key={index}>{paragraph}</PopUpBodyText>;
  });

  return (
    <>
      {state.telemetry && popuppage.name1 === "localaudio" && (
        <>
          {bodyOffText}
          <PopUpBodyText>Device Mode: Telemetry</PopUpBodyText>
        </>
      )}

      {!state.telemetry &&
        popuppage.name1 === "localaudio" &&
        state.piicConnected && (
          <>
            {bodyOnText}
            <PopUpBodyText>Device Mode: Monitor</PopUpBodyText>
          </>
        )}

      {!state.telemetry &&
        popuppage.name1 === "localaudio" &&
        !state.piicConnected && (
          <>
            {bodyPicOffText}
            <PopUpBodyText>Device Mode: Monitor</PopUpBodyText>
          </>
        )}

      {body}
    </>
  );
};

export default PopUpBody;
